import { notizarten, notizfarben } from "./globalVariables";

export default function NotizArtenTabs({ selectedNotizart, setSelectedNotizart }) {
   return (
      <>
         <ul className="nav nav-tabs mb-2">
            <li className="nav-item" key={"Alle"}>
               <button
                  style={{
                     height: "60px",
                     marginBottom: "-2px",
                     fontWeight: 900,
                     color: "#000",
                  }}
                  className={"nav-link" + ("Alle" === selectedNotizart ? " active" : "")}
                  name={"Alle"}
                  aria-current="page"
                  onClick={(e) => {
                     console.log(e.target.name);
                     setSelectedNotizart(e.target.name);
                  }}
               >
                  {"Alle"}
               </button>
            </li>
            {notizarten.map((notizart, index) => (
               <li className="nav-item" key={notizart.value}>
                  <button
                     style={{
                        height: "60px",
                        marginBottom: "-2px",
                        fontWeight: 900,
                        color: notizfarben[notizart.value] ? notizfarben[notizart.value] : "#000",
                     }}
                     className={"nav-link" + (notizart.value === selectedNotizart ? " active" : "")}
                     name={notizart.value}
                     aria-current="page"
                     onClick={(e) => {
                        console.log(e.target.name);
                        setSelectedNotizart(e.target.name);
                     }}
                  >
                     {notizart.name}
                  </button>
               </li>
            ))}
         </ul>
      </>
   );
}
